//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FacultyHeader from '@/components/redesign/coding/FacultyHeader'
import StartSection from '@/components/redesign/coding/StartSection'
import FeaturesSection from '@/components/redesign/coding/FeaturesSection'
import WorldSection from '@/components/redesign/coding/WorldSection'
import CommentSection from '@/components/redesign/coding/CommentSection'
import SummerSection from '@/components/redesign/coding/SummerSection'
import CoursesSection from '@/components/redesign/coding/CoursesSection'
import ClaimSection from '@/components/redesign/coding/ClaimSection'
import RoadmapSection from '@/components/redesign/coding/RoadmapSection'

export default {
  name: 'CodingTop',
  components: {
    FacultyHeader,
    StartSection,
    FeaturesSection,
    WorldSection,
    CommentSection,
    SummerSection,
    CoursesSection,
    ClaimSection,
    RoadmapSection,
  },
}
